import template from './title-bar.jade';

let mod = angular
  .module('app.directives.title-bar', [])
  .directive('titleBar', $state => ({
    restrict: 'E',
    template,
    link(scope, element, attrs) {
      scope.$watch(
        () => $state.current.name,
        () =>
          (scope.bar =
            $state.current.titleBar != null ? $state.current.titleBar : null)
      );
    },
  }));

export default mod;
